import React, { Fragment, useState, useRef } from "react"
import { accessRole } from "../../../../helpers/access_role"
import { Link } from "react-router-dom"
import { Container, Row, Col, CardBody, Card, CardTitle, Button } from "reactstrap"
import TablePrimaryComponent from './Components/TablePrimaryComponent'

const IndexView = (props) => {
    const tableRef = useRef()

    const reloadTable = () => tableRef.current.setTokenAPI()

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        <Card className="">
                            <CardBody>
                                <div className="float-end">
                                    {accessRole('create') && (
                                        <Link to="?template-surat=create">
                                            <Button color="primary">Tambah Template Surat</Button>
                                        </Link>
                                    )}
                                </div>
                                <CardTitle className="mb-4">Daftar Template Surat</CardTitle>
                                <TablePrimaryComponent ref={tableRef} onRefresh={reloadTable} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView

